import '../../image_upload_view.js.coffee';# Added by Script 
class AccountSettings.MailImageUploadView extends Monitoring.Views.ImageUploadView
  template: JST["backbone/templates/account_settings/social_accounts/mail_image_attachment"]

  resetFile:(image)->
    super(image)
    @response.removeLabel()
    @_resetImageUploader()

    @$el.append(@_flushUpload())

  _uploadFile: (input) ->
    super(input)
    @$el.find("#file-image-remove-input").remove()

  _flushUpload: ->
    '<input type="text" id="file-image-remove-input" style="display: none;" class="hidden" name="remove_image" value="true">'
